import React, {Component} from 'react';
import {Col, Form, Input, Label, FormGroup, Button} from 'reactstrap';
import * as customers from 'customers/actions/customers';
import {connect} from 'react-redux';
import {DetailContainer} from 'customers/DetailContainer';
import autobind from 'autobind-decorator';
import Dialog from 'apa/containers/Dialog';
import * as notes from 'customers/actions/notes';
import Loading from 'apa/components/Loading';
import {formatDate} from 'invoices/containers/InvoiceDetail';

@connect(
    state => {
        return {
            customers: state.customers,
        }
    },
    dispatch => {
        return {
            fetchCustomer: (customer_id, callback) => {
                dispatch(customers.fetchCustomer(customer_id, callback))
            },
            add: (note, callback) => {
                dispatch(notes.add(note, callback))
            }
        }
    }
)
export default class NoteList extends Component {


    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            customer: null,
            noteList: [],
            isNewNoteModalOpen: false,
            newNote: {
                subject: '',
                note: '',
                date: formatDate(new Date())
            }
        };
    }

    componentDidMount() {
        const id = this.props.match.params.id;
        this.props.fetchCustomer(id, customer => this.setState({
            isLoading: false,
            customer: customer,
            noteList: customer.notes
        }))
    }

    @autobind
    toggleNewNoteModal() {
        this.setState(
            {
                ...this.state,
                isNewNoteModalOpen: !this.state.isNewNoteModalOpen
            }
        )
    }

    @autobind
    confirmNewNote() {
        this.props.add(
            {
                ...this.state.newNote,
                customer: this.state.customer.id
            },
            note => this.setState({
                noteList: [note, ...this.state.noteList]
            })
        );
        this.toggleNewNoteModal();
    }

    @autobind
    handleInput(event) {
        const value = event.target.value;
        const name = event.target.name;
        this.setState(
            {
                ...this.state,
                newNote: {
                    ...this.state.newNote,
                    [name]: value
                }
            }
        )
    }

    render() {
        const id = this.props.match.params.id;
        const customer = this.state.customer;
        if (this.state.isLoading)
            return <Loading/>;
        const notes = this.state.noteList || [];
        return (
            <DetailContainer id={id}>
                <h1>{customer.name}</h1>
                <Button color='primary' onClick={this.toggleNewNoteModal}>
                    Sonderinformation hinzufügen
                </Button>
                <Dialog
                    isOpen={this.state.isNewNoteModalOpen}
                    toggle={this.toggleNewNoteModal}
                    confirm={this.confirmNewNote}
                    title={'Sonderinformation hinzufügen'}
                >
                    <Form>
                        <FormGroup>
                            <Label>
                                Datum
                            </Label>
                            <Input value={this.state.newNote.date} type="date" name="date"
                                   onChange={this.handleInput}/>
                        </FormGroup>
                        <FormGroup>
                            <Label>
                                Betreff
                            </Label>
                            <Input value={this.state.newNote.subject} type="text" name="subject"
                                   onChange={this.handleInput}/>
                        </FormGroup>
                        <FormGroup>
                            <Label>
                                Text
                            </Label>
                            <Input type={'textarea'} value={this.state.newNote.note} name="note"
                                   onChange={this.handleInput}/>
                        </FormGroup>
                    </Form>

                </Dialog>
                {
                    notes.map(
                        note => <CustomerNote key={`customer_note_${note.id}`} note={note}/>
                    )
                }
            </DetailContainer>
        )
    }
}

@connect(
    state => (
        {
            auth: state.apa
        }
    )
)
class CustomerNote extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isSubmitting: false,
            note: props.note,
            deleted: false,
            show: false
        }
    }

    @autobind
    handleChange(event) {
        const target = event.target;
        const name = target.name;
        const value = target.value;
        this.setState({
            note: {
                ...this.state.note,
                [name]: value
            }
        })
    }

    @autobind
    toggle() {
        this.setState({show: !this.state.show})
    }

    @autobind
    submit() {
        if (!this.state.isSubmitting) {
            this.setState({
                isSubmitting: true
            });
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Token ${this.props.auth.token}`
            };
            const body = JSON.stringify(this.state.note);
            fetch(
                `/api/notes/${this.state.note.id}/`,
                {headers, method: 'PATCH', body}
            ).then(
                res => res.json()
            ).then(note => {
                    this.setState({
                        isSubmitting: false,
                        note: note
                    })
                }
            )
        }
    }

		@autobind
	delete() {
		const headers = {
			'Content-Type': 'application/json',
			'Authorization': `Token ${this.props.auth.token}`
		};
		fetch(
			`/api/notes/${this.state.note.id}/`,
			{headers, method: 'DELETE'}
		).then(
			() => this.setState({deleted: true})
		)
	}

	render() {
		const {note, show, deleted} = this.state;
        if(deleted)
            return null;
		return (
			<Form>
				<hr/>
				<FormGroup row>
					<Label for="date" sm={2}>
							Datum
					</Label>
					<Col sm={3}>
						<Input value={note.date} type="date" onChange={this.handleChange} name="date"
							onBlur={this.submit}/>
					</Col>
                    <Label sm={2} for="subject">
                        Betreff
                    </Label>
                    <Col sm={4}>
                        <Input onChange={this.handleChange} onBlur={this.submit} value={note.subject} type="text"
                               name="subject"/>
                    </Col>
                    <Col sm={1} className='text-right'>
                        <Button onClick={this.delete}>
                            <i className='fa fa-trash'> </i>
                        </Button>
                    </Col>
                </FormGroup>
                <FormGroup>
                    <Label for="note">
                        <a href="#" onClick={this.toggle}>Text</a>
                    </Label>
                    {
                        show &&
                        <Input onChange={this.handleChange} onBlur={this.submit} type='textarea' name='note'
                               value={note.note}/>
                    }
                </FormGroup>
            </Form>
        )
    }
}

